import { useAuth } from "../../auth/hooks/useAuth";
import { UserRole } from "../enums/UserRole";
import { useLocation } from "react-router";

export const useUserId = (): string => {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const isAdminOrSupport = [
    UserRole.Owner,
    UserRole.Admin,
    UserRole.Support,
  ].includes(user.role);
  const userIdFromPath = pathname.split("user/")[1]?.split("/")[0];

  const userId = isAdminOrSupport ? userIdFromPath : user.id;

  return userId;
};
